(function () {
  function init(section) {
    var track = section.querySelector('.hp-test__track');
    var prev = section.querySelector('.hp-test__btn--prev');
    var next = section.querySelector('.hp-test__btn--next');
    if (!track || !prev || !next) return;

    function pageWidth() {
      var first = track.querySelector('.hp-test__card');
      if (!first) return track.clientWidth;
      var rect = first.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return rect.width + gap;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -pageWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: pageWidth(), behavior: 'smooth' });
    });
  }

  function boot() {
    document.querySelectorAll('[data-hp-test]').forEach(function (el) {
      if (el.__hpTestReady) return;
      el.__hpTestReady = true;
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
